// extracted by mini-css-extract-plugin
module.exports = {"container":"AddProvider_container__29gUD","content":"AddProvider_content__p58m1","navigation":"AddProvider_navigation__3PvYH"};